export const openInGraphQuery = (entityKey: string) => {
  return `FIND * WITH _key="${entityKey}" THAT RELATES TO * RETURN TREE`;
};
